import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBzA0Rx5D6EqGT4a6MYJgzg9IJslEuf8_g',
  authDomain: 'stilingue-dashboard.firebaseapp.com',
  databaseURL: 'https://stilingue-dashboard.firebaseio.com',
  projectId: 'stilingue-dashboard',
  storageBucket: 'stilingue-dashboard.appspot.com',
  messagingSenderId: '873545207447',
  appId: '1:873545207447:web:39558245b79e846deb63d2',
  measurementId: 'G-C6R8XBX4W3'
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth().useDeviceLanguage();

window.firebase = firebase;

const { Timestamp } = firebase.firestore;

export default firebase;

export { Timestamp };

export function firestoreTimestampFromDate(date = new Date()) {
  return Timestamp.fromDate(date);
}
